<template>
  <v-card class="mx-auto" max-width="600">
    <v-card-title>
      <v-icon large left>mdi-printer</v-icon>
      <span class="title font-weight-light">Canon IPF6400SE</span>
    </v-card-title>

    <v-container>
      <span class>Status:</span>
      <span v-if="Math.random() > 0.5">
        <v-icon color="green darken-3" class="mx-2">mdi-access-point-network</v-icon>
        <span class="subheading">Online</span>
      </span>

      <span v-else>
        <v-icon color="red darken-3" class="mx-2">mdi-access-point-network-off</v-icon>
        <span class="subheading">Offline</span>
      </span>
    </v-container>
    <v-container class="mt-n4">
      <span class="subheading mr-2">IP:</span>
      <span class="subheading">192.168.50.25</span>
    </v-container>
    <v-divider class="mx-3"></v-divider>

    <v-container class="my-n2" v-for="ink in inks" :key="ink.name">
      <span>{{ink.name}}</span>
      <v-progress-linear
        :height="ink.height || '10'"
        :rounded="ink.rounded"
        :value="randomNumber()"
        :color="ink.color"
      ></v-progress-linear>
    </v-container>
    <v-divider class="mx-3 pb-2"></v-divider>
  </v-card>
</template>

<script>
export default {
  methods: {
    randomNumber: function() {
      return Math.random() * 100;
    }
  },
  data: () => ({
    inks: [
      {
        name: 'Cyan',
        value: '',
        color: '#00FFFF',
        rounded: 'false',
        height: ''
      },
      {
        name: 'Magenta',
        value: '',
        color: '#ff00ff',
        rounded: '',
        height: ''
      },
      {
        name: 'Yellow',
        value: '',
        color: '#ffff00',
        rounded: '',
        height: ''
      },
      {
        name: 'Black',
        value: '',
        color: 'black',
        rounded: '',
        height: ''
      },
      {
        name: 'Matte Black',
        value: '',
        color: '#292929',
        rounded: '',
        height: ''
      },
      {
        name: 'Red',
        value: '',
        color: '#FF0000',
        rounded: '',
        height: ''
      }
    ]
  })
};
</script>

<style scoped>
</style>